export const apiURL = process.env.VUE_APP_BASE_URL + '/api'
export const VUE_APP_I18N_LOCALE = 'en'
export const VUE_APP_I18N_FALLBACK_LOCALE = 'ru'
export const VUE_APP_I18N_SUPPORTED_LOCALE = 'en,ru,de,fr'
